import { z } from 'zod';

export const formSchema = z
  .object({
    name: z.string().min(1, 'Name required'),
    description: z.string().optional(),
    contract: z.string().optional(),
    startDate: z.string().min(1, 'Start Date required'),
    endDate: z.string().optional(),
    businessGroup: z.string().min(1, 'Business Group required'),
    products: z.array(z.string()).optional(),
    services: z.array(z.string()).optional(),
  })
  .refine(
    d => {
      if (!d.startDate || !d.endDate) {
 return true;
}

      return new Date(d.endDate) >= new Date(d.startDate);
    },
    { path: ['endDate'], message: 'End date must be on or after start date' },
  );

export type AssignmentFormValues = typeof formSchema._type;
